<template>
  <div class="g-container">
    <div class="contactUs-banner">
      <img src="../../../html/pages/help/contactUs/images/banner.jpg" alt />
    </div>
    <div class="contactUs-container">
      <div class="contactUs-container-title">
        <p>我们的优势</p>
        <p>OUR ADVANTAGE</p>
      </div>
      <ul class="contactUs-container-list">
        <li>
          <img src="../../../html/pages/help/contactUs/images/1.png" alt />
          <p>透明施工、社会监督、</p>
          <p>进度可视化</p>
        </li>
        <li>
          <img src="../../../html/pages/help/contactUs/images/2.png" alt />
          <p>权威的现场施工、</p>
          <p>解决方案</p>
        </li>
        <li>
          <img src="../../../html/pages/help/contactUs/images/3.png" alt />
          <p>绿建、教体同行的</p>
          <p>圈内互动</p>
        </li>
        <li>
          <img src="../../../html/pages/help/contactUs/images/4.png" alt />
          <p>第一时间的行业资讯</p>
          <p>及观点</p>
        </li>
        <li>
          <img src="../../../html/pages/help/contactUs/images/5.png" alt />
          <p>绿建防护与维修平台</p>
          <p>堆品质信用，绿安全环境</p>
        </li>
      </ul>
      <div class="contactUs-container-title">
        <p>联系我们</p>
        <p>CONTACT US</p>
      </div>
      <ul class="contactUs-container-contactList">
        <li>
          <p>公司地址</p>
          <p>苏州堆绿云科技有限公司</p>
          <p>地理位置：苏州市高新区鸿禧路99号</p>
        </li>
        <li>
          <p>联系方式</p>
          <p>联系电话：4006803807</p>
          <p>手机号码：180 1319 8377</p>
        </li>
        <li>
          <p>网络联系</p>
          <p>联系QQ： 809179396</p>
          <p>邮箱地址：iduilv@126.com</p>
        </li>
      </ul>
    </div>
    <baidu-map class="map" :center="center" :zoom="zoom" @ready="handler" ak="uVdH4iqsEd2BPnlCupOlHFUytU7eqiWL&s=1"
      :scroll-wheel-zoom="true">
      <bm-marker :position="center"></bm-marker>
    </baidu-map>
  </div>
</template>
<style>
@import "../../../html/pages/help/contactUs/contactUs.css";
</style>
<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
// import BmLabel from 'vue-baidu-map/components/map/Map.vue'
export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },  //经纬度
      zoom: 15　 //地图展示级别
    }
  },
  components: {
    BaiduMap,
    BmMarker,
  },
  methods: {
    handler({ BMap, map }) {
      console.log(BMap, map)
      this.center.lng = 120.502
      this.center.lat = 31.351
      this.zoom = 17
    }
  }
}
</script>


